<template>
  <div class="pt-10 pb-5 component-div">
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable && isFieldDisabled == false"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <span v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>
          <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
            <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-45 pt-10">
        <b-form-textarea type="text" name="activityFormTextPreview" disabled rows="6" />
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-if="componentData.isSkippable"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <span v-if="hasFieldError" class="text-danger pl-5 fw-bold">{{ fieldErrorText }}</span>
          <span v-if="hasFieldWarning" class="text-warning pl-5 fw-bold">{{ fieldWarningText }}</span>
        </b-col>
      </b-row>

      <b-row class="mb-10 mt-5 pl-43" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="5">
          <textarea class="mb-0 form-control" type="text" name="activityFormTextPreview" v-model="value" :disabled="isFieldDisabled" v-on:change="onFieldChange" rows="6" :class="{ 'is-danger': hasFieldError }" />
        </b-col>
        <b-col cols="7"> </b-col>
        <b-col cols="8"></b-col>
      </b-row>
      <div :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-55" :class="{ clearOptionDisabled: isFieldDisabled }" @click="clearAnswer" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label class="fs-12" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">{{ componentData.actualScore || showScore(componentData.skipScore) }}</div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col cols="10" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <span v-if="isFieldDisabled" class="askipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>
        </b-col>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="answers ml-16">{{ componentData.answer }}</div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label>Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-text-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      value: ""
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    isClearData: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    },
    hasFieldError(val) {
      this.componentData.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.componentData.fieldErrorText = val;
    },
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.checkForFieldErrors();
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },
  mounted() {
    this.value = this.componentData.answer;
    if (this.mode == 1) {
      this.$emit("initAnswerChange", this.componentData);
    }
  },
  methods: {
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.value = "";
      this.componentData.answer = "";
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.resetAllErrors();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
      this.resetAllErrors();
    },
    onFieldChange() {
      this.checkForFieldErrors();
      this.onAnswerChange();
    },
    validateCharacterLimit(answer, hasLimit, characterLimit) {
      if (hasLimit && answer.length > characterLimit) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than ${characterLimit}.`, { CHAR_LIMIT: characterLimit });
        return true;
      }
      if (hasLimit == false && answer.length > 4096) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than 4096.`, { CHAR_LIMIT: 4096 });
        return true;
      }
      return false;
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    checkForFieldErrors() {
      this.componentData.answer = this.value;
      let { answer, characterLimited, textLimit, isSkippable, dataEditChecks } = this.componentData;
      this.resetAllErrors();
      this.componentData.dataChecks = [];

      if (this.validateCharacterLimit(answer, characterLimited, textLimit)) {
        return;
      }

      if (dataEditChecks) {
        let softDataCheck = false;
        const alphanumericRegx = /^[a-zA-Z0-9 ]*$/;
        const numericRegx = /^[0-9 ]+$/;
        const alphabetRegx = new RegExp("^[a-zA-Z ]+$");
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && answer == "") {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is requested. Please enter a response.`;

              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });

              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphabet" && !alphabetRegx.test(answer)) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              isSkippable = true;
              this.fieldWarningText = `Your response is not in the expected format: Alphabet. Please review your response.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Numeric" && !numericRegx.test(answer)) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              isSkippable = true;
              this.fieldWarningText = `Your response is not in the expected format: Numeric. Please review your response.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphanumeric" && !alphanumericRegx.test(answer)) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              isSkippable = true;
              this.fieldWarningText = `Your response is not in the expected format: Alphanumeric. Please review your response.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
          } else {
            if ((dataEditChecks[k].type == "NOT_BLANK" && answer == "") || answer == undefined) {
              this.hasFieldWarning = false;
              this.fieldWarningText = "";
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response.";
              isSkippable = false;

              return false;
            } else if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphabet" && !alphabetRegx.test(answer)) {
              this.hasFieldWarning = false;
              this.fieldWarningText = "";
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response with format: Alphabet.";
              isSkippable = false;
              return false;
            } else if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Alphanumeric" && !alphanumericRegx.test(answer)) {
              this.hasFieldWarning = false;
              this.fieldWarningText = "";
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response with format: Alphanumeric.";
              isSkippable = false;
              return false;
            } else if (dataEditChecks[k].type == "DATA_TYPE" && dataEditChecks[k].value == "Numeric" && !numericRegx.test(answer)) {
              this.hasFieldWarning = false;
              this.fieldWarningText = "";
              this.hasFieldError = true;
              this.fieldErrorText = "Please enter a response with format: Numeric.";
              isSkippable = false;
              return false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if ((isSkippable && (answer == "" || answer == undefined)) || this.isFieldDisabled) {
        return;
      }

      if (!isSkippable && (answer == "" || answer == undefined)) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
        return;
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.answer = this.value;
        this.componentData.computedScore = this.componentData.score;
        this.componentData.actualScore = this.componentData.score;
        this.$emit("onAnswerChange", this.componentData);
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
